import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/legacy-src/lib/utils'

import { Slot, type SlotProps } from '@/src/domains/design-system/components/Slot'

const headingVariants = cva('mb-0 font-serif', {
  variants: {
    variant: {
      xl: 'text-xl',
      '2xl': 'text-2xl',
      '3xl': 'text-3xl',
      '4xl': 'text-4xl',
      '5xl': 'text-5xl',
    },
    weight: {
      regular: 'font-normal',
      semibold: 'font-semibold',
    },
  },
  defaultVariants: { variant: 'xl', weight: 'semibold' },
})

type HeadingVariantsProps = VariantProps<typeof headingVariants>

export type HeadingProps = SlotProps<'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'dd' | 'dt'> &
  HeadingVariantsProps & {
    className?: string
  }

export const Heading = (props: HeadingProps) => {
  const { variant, weight, className, ...rest } = props

  return <Slot {...rest} className={cn(headingVariants({ variant, weight, className }))} />
}
